<template>
   <div>
       <h5>Account details</h5>

       <ValidationObserver class="row" ref="form">
           <ValidationProvider class="col-md-6 mb-3" name="Name" rules="required" v-slot="{ errors }">
               <label for="name" class="form-label">Name:*</label>
               <div class="form-group mb-0">
                   <input id="name" type="email" :class="['form-control mb-1', {'input-error' : errors[0] }]" v-model="paypal.name">
               </div>

               <div :class="['form-group field-validation-error', {'animated shake': errors[0] && animated }]" >
                   {{ errors[0] }}
               </div>
           </ValidationProvider>

           <ValidationProvider class="col-md-6 mb-3" name="Email" rules="required|email" v-slot="{ errors }">
               <label for="email" class="form-label">Email:*</label>
               <div class="form-group mb-0">
                   <input id="email" type="email" :class="['form-control mb-1', {'input-error' : errors[0] }]" v-model="paypal.email">
               </div>

               <div :class="['form-group field-validation-error', {'animated shake': errors[0] && animated }]" >
                   {{ errors[0] }}
               </div>
           </ValidationProvider>
       </ValidationObserver>
   </div>
</template>

<script>
    import resetAnimation from "../../../../../../resources/js/mixins/reset-animation";

    export default {
        name: "PaymentPaypal",
        mixins:  [ resetAnimation ],
        data() {
            return {
                paypal: {
                    name: null,
                    email: null,
                },
            }
        },
        methods: {
            resetForm() {
                for (const key in this.paypal) {
                    if (this.paypal.hasOwnProperty(key)) {
                        this.paypal[key] = null;
                    }
                }
            },
        }
    }
</script>

<style scoped>
    .field-validation-error {
        color: #d54141;
        font-family: Open Sans, sans-serif;
        font-size: 13px;
        font-weight: 400;
        margin-bottom: 0;
    }

    .input-error {
        border: 2px solid #ffb996 !important;
        background-color: #fff8f6 !important;
        border-radius: 3px !important;
    }
</style>
